<template>
    <b-container>
        <button-row :Buttons="Buttons" v-if="!fetching"></button-row>
        <div v-for="(agenda, agenda_i) in event.event_agenda" :key="agenda_i" class="mt-3">
            <event-core-info :event="event" :agenda="agenda" :detailView="true"></event-core-info>
            <location-details
                :address="{
                    location: agenda.agenda_location,
                    street: agenda.agenda_street,
                    zip: agenda.agenda_zip,
                    city: agenda.agenda_city,
                    country: agenda.agenda_country,
                    meeting_point: agenda.agenda_meeting_point
                }"
            ></location-details>
            <b-btn v-if="userListExpandable" @click="toggleUserList(agenda_i)" style="font-size: 18px;" variant="link border-0" class="btn-block pt-2 px-0 d-flex align-items-center justify-content-between"><strong>Teilnehmerliste anzeigen</strong><svg-icon-double-arrow-down></svg-icon-double-arrow-down></b-btn>
            <b-collapse :id="`user-list-${agenda_i}`" :visible="event.event_agenda.length == 1">
                <user-list :agenda="agenda" class="mb-4" :expandable="userListExpandable" :hideDetailButton=true></user-list>
            </b-collapse>
            <b-row class="border-bottom border-primary" v-if="agenda_i < event.event_agenda.length - 1"></b-row>
        </div>
        
    </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ButtonRowVue from '../components/ButtonRow.vue'
import EventCoreInfoVue from '../components/EventCoreInfo.vue'
import LocationDetailsVue from '../components/Location-Details.vue';
import UserListVue from '../components/Event-User-List.vue';
import SvgIconDoubleArrowDown from '@/components/svg-icon/DoubleArrowDown.vue';
export default {
    name: 'event-detail-cmp',
    components: {
        'button-row': ButtonRowVue,
        'event-core-info': EventCoreInfoVue,
        'location-details': LocationDetailsVue,
        'user-list': UserListVue,
        'svg-icon-double-arrow-down': SvgIconDoubleArrowDown
    },
    props: {
    },
    data() {
        return {
        }
    },
    mounted() {
        this.init();
    },
    // watch: {
    //     fetching(newValue) {
    //         // console.log(newValue, this.event);
    //     }
    // },
    computed: {
        ...mapGetters('auth', ['loggedIn', 'isActivity']),
        ...mapGetters('events', ['fetching', 'event']),
        Buttons() {
            const buttons = [
                {
                    title: 'Zurück',
                    to: '/event-list',
                    variant: 'light border',
                    icons: {
                        left: {
                            icon: ['far', 'arrow-left'],
                            visible: true
                        },
                        right: {
                            icon: ['far', 'arrow-right'],
                            visible: false
                        }
                    }
                },
                {
                    title: 'Anmeldung',
                    to: 'application',
                    variant: 'primary',
                    icons: {
                        left: {
                            icon: ['far', 'arrow-left'],
                            visible: false
                        },
                        right: {
                            icon: ['far', 'arrow-right'],
                            visible: false
                        }
                    },
                    data: {agenda: [], event_id: null}
                    // data: {agenda: this.event.event_agenda, event_id: this.event.ID}
                }
            ]

            if(!this.fetching && this.event) {
                buttons[1].data.agenda = this.event.event_agenda;
                buttons[1].data.event_id = this.event.ID;

                if (this.isActivity) {
                    buttons.push({
                        title: 'Anwesenheit',
                        to: { name: 'presence', params: { Id: this.event.ID }},
                        variant: 'primary',
                        icons: {
                            left: {
                                icon: ['far', 'arrow-left'],
                                visible: false
                            },
                            right: {
                                icon: ['far', 'arrow-right'],
                                visible: false
                            }
                        },
                        data: {agenda: this.event.event_agenda, event_id: this.event.ID}
                    });
                    if (this.isActivity) {
                        buttons.push({
                            title: 'Bearbeiten',
                            to: { name: 'event-edit', params: { Id: this.event.ID }},
                            variant: 'light border',
                            icons: {
                                left: {
                                    icon: ['far', 'arrow-left'],
                                    visible: false
                                },
                                right: {
                                    icon: ['far', 'arrow-right'],
                                    visible: false
                                }
                            },
                        });
                    }
                }
            }
            return buttons;
        },
        userListExpandable() {
            return this.event.event_agenda.length > 1;
        }
    },
    methods: {
        ...mapActions('events', ['fetchEvent']),
        init() {
            this.fetchEvent(this.$route.params.Id);
            this.addEventListener();
        },
        addEventListener() {
            // Event.$emit('saveApplicationSuccess', event);
            window.LC_Event.$on('saveApplicationSuccess', () => {
                // console.log(data, this.$route.params.Id);
                this.fetchEvent(this.$route.params.Id);
            })
        },
        toggleUserList(agenda_index) {
            this.$root.$emit('bv::toggle::collapse', `user-list-${agenda_index}`);
        }
    }
}
</script>

<style lang="scss">
    @import '../scss/variables';
@import 'bootstrap/scss/bootstrap.scss';
.border-bottom {
    border-bottom-width: 2px !important
}
</style>